import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-heading font-black text-primary-500 tracking-tight">
              黑料社区
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-400'
                  : 'text-foreground-400 hover:text-foreground-200'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/star-gossip"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-400'
                  : 'text-foreground-400 hover:text-foreground-200'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-400'
                  : 'text-foreground-400 hover:text-foreground-200'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300 hover:text-foreground-100 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100 border-t border-background-300/60">
          <div className="px-4 py-4 flex flex-col gap-4">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap ${
                location.pathname === '/' ? 'text-primary-400' : 'text-foreground-300'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/star-gossip"
              className={`text-sm font-medium whitespace-nowrap ${
                location.pathname.startsWith('/category') ? 'text-primary-400' : 'text-foreground-300'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap ${
                location.pathname === '/about' ? 'text-primary-400' : 'text-foreground-300'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}